<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير الحضور والغياب'" :to="{name: 'reports.lessonAbsences'}">  تقرير الحضور والغياب</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير الحضور والغياب
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div class="col-md-6 mt-2">
                                          <label for=""> التاريخ من <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                         <div class="col-md-6 mt-2">
                                          <label for="">التاريخ إلى <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" @select="getLessons" :multiple="false" />
                                        </div>
                                        <div class="col-md-6">
                                          <label for="">الحلقة <span class="text-danger">*</span></label>
                                          <treeselect :required="true" :options="lessons" v-model="data.searching.lesson_id" @select="getStudents" :multiple="false" />
                                        </div>
                                       
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive" >
                                  <div class="col-md-12 mb-2">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="(data.data && data.data.length > 0)" @click.prevent="exportAttendanceExcel">
                                    تصدير Excel
                                  </button>

                                  </div>
                                  <div class="col-md-12" id="printMe">
                                    <table class="table table-bordered mb-4" v-if="data.data.length">
                                    <thead>
                                           <tr>
                                            <th>اسم التقرير</th>
                                            <th colspan="2">التاريخ من</th>
                                            <th colspan="2">التاريخ إلى</th>
                                            <th>الصف الدراسى</th>
                                            <th>الحلقة </th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>تقرير الحضور والغياب</td>
                                            <td colspan="2">
                                              {{ data.searching.date_from }}
                                            </td>
                                            <td colspan="2">
                                              {{ data.searching.date_to }}
                                            </td>
                                            <td>
                                              {{ getLabelById(groups, data.searching.group_id) }}
                                            </td>
                                            <td>
                                              {{ getLabelById(lessons, data.searching.lesson_id) }}
                                            </td>
                                          </tr>
                                        </tbody>
                                  </table>

                                  <table class="table table-bordered mb-4" v-if="data.data.length">
                                        <thead>
                                           <tr>
                                            <th>التاريخ</th>
                                            <th>الحلقة</th>
                                            <th>عدد الحضور</th>
                                            <th>عدد الغياب</th>
                                            <th>عدد حالات التأخير</th>
                                            <th>عدد حالات الاستأذان</th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(deg, i) in data.data" :key="i">
                                            <td>{{ deg.date }}</td>
                                            <td>{{ deg.lesson }}</td>
                                            <td>
                                              <a :href="'/reports/student-lesson-absences?type=presence&i=' + data.searching.lesson_id + '&d=' + deg.date" target="_blank">
                                                {{ deg.pre }}
                                              </a>
                                            </td>
                                            <td>
                                              <a :href="'/reports/student-lesson-absences?type=absence&i=' + data.searching.lesson_id + '&d=' + deg.date" target="_blank">
                                              {{ deg.abs }}
                                              </a>
                                            </td>
                                            <td>
                                              <a :href="'/reports/student-lesson-absences?type=delay&i=' + data.searching.lesson_id + '&d=' + deg.date" target="_blank">
                                              {{ deg.del }}
                                              </a>
                                            </td>
                                            <td>
                                              <a :href="'/reports/student-lesson-absences?type=excuse&i=' + data.searching.lesson_id + '&d=' + deg.date" target="_blank">
                                              {{ deg.exc }}
                                              </a>
                                            </td>
                                          </tr>
                                          
                                        </tbody>
                                        <tfoot>
                                          <tr >
                                            <th colspan="2" class="text-center">الاجمالى</th>
                                            <th>{{ data.total.p }}</th>
                                            <th>{{ data.total.a }}</th>
                                            <th>{{ data.total.d }}</th>
                                            <th>{{ data.total.e }}</th>
                                          </tr>
                                        </tfoot>
                                    </table>
                                  </div>
                                  <div class="col-md-12">
                                    <button class="btn btn-success" v-if="data.data.length" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="(data.data && data.data.length > 0)" @click.prevent="exportAttendanceExcel">
                                    تصدير Excel
                                  </button>
                                  </div>
                                 
                                    
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapGetters } from 'vuex'
import * as XLSX from "xlsx";

export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      isRequested: false,

      chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      printData: {
      },
      data: {
        data: {},
        info: {},
        total: {},
        searching:{
            group_id: '',
            lesson_id: '',
            student_id: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.search(null, '', this, 'lesson');
      this.search(null, '', this, 'group');
  },
  methods: {
      exportAttendanceExcel() {
      const wb = XLSX.utils.book_new();
      const self = this;

      // Safe Excel sheet name
      function safeSheetName(name) {
        if (!name) return "تقرير";
        return name.toString().replace(/[\[\]\*\/\\\?\:]/g, "").substring(0, 31);
      }

      // =========================
      // Build sheet
      // =========================
      const rows = [];

      // Header info table
      rows.push(["اسم التقرير", "التاريخ من", "", "التاريخ إلى", "", "الصف الدراسى", "الحلقة"]);
      rows.push([
        "تقرير الحضور والغياب",
        self.data.searching.date_from,
        "",
        self.data.searching.date_to,
        "",
        self.getLabelById(self.groups, self.data.searching.group_id),
        self.getLabelById(self.lessons, self.data.searching.lesson_id)
      ]);
      rows.push([]); // empty row

      // Daily attendance table header
      rows.push([
        "التاريخ",
        "الحلقة",
        "عدد الحضور",
        "عدد الغياب",
        "عدد حالات التأخير",
        "عدد حالات الاستأذان"
      ]);

      // Daily data
      if (Array.isArray(self.data.data)) {
        self.data.data.forEach(function (deg) {
          rows.push([
            deg.date,
            deg.lesson,
            deg.pre,
            deg.abs,
            deg.del,
            deg.exc
          ]);
        });
      }

      // Totals (tfoot)
      rows.push([
        "الاجمالى",
        "",
        self.data.total.p,
        self.data.total.a,
        self.data.total.d,
        self.data.total.e
      ]);

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(rows);

      // RTL support
      ws["!rtl"] = true;

      // Column widths
      ws["!cols"] = [
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 }
      ];

      // Append sheet
      XLSX.utils.book_append_sheet(wb, ws, safeSheetName("Attendance Report"));

      // Save file
      XLSX.writeFile(wb, "attendance-report.xlsx");
    },
    getLabelById(arr, id){
      if(arr.length){
        for (let index = 0; index < arr.length; index++) {
        let element = arr[index];
        if(element.id == id){
          return element.label;
        }
        
      }
      }
      
      return '';
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', 'تقرير الحضور والغياب');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val){
      this.$baseApi.get('/reports/absences?pluck=1&group='+val.id+'&i='+val.id+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+this.data.searching.lesson_id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        if(this.data.searching.date_from == '' || this.data.searching.date_to == '' || this.data.searching.lesson_id == ''){
          return;
        }
        this.isRequested = true;
        this.$baseApi.get('/reports/lesson-absences?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data.data;
              this.data.total = response.data.data.counting;
              this.isRequested = false;
              
            }else{
                alert(response.data.error.error);
                this.isRequested = false;

            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    ...mapGetters({
      settings: 'GET_WEBSITE_SETTING_KEYS'
    })
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
